import React from "react";
import { useTranslation } from "react-i18next";

import classes from "./TextSide.module.css";

const TextSide = () => {
  const { t } = useTranslation();

  return (
    <div className={classes["wrapper"]}>
      <h2 className={classes["title"]}>{t("About our school")}</h2>
      <p className={classes["description"]}>
        {t(
          "Toshkent city 249-school which is located in the Olmazor district has been started their first work in 1975 by Sharof Rashidov. Nowadays, 3156 students study and practice, our students are being teached in russion, uzbek languages. We have 151 professional teachers, they have different certificates and their students always take a good place in different competitions. We hope you will choose our school to study well"
        )}
      </p>
    </div>
  );
};

export default TextSide;
